const { Core, Events, Utils, Store } = Global;
const { getBrowserName, $active, $fetch, parseHTML, $clone, $loading, isFunction, $replaceContent, $toggleDisplay } = Utils;

const COMPARING_URLS_STORE_KEY = 'compare';
const CHECKSUM_STORE_KEY = 'compare-products-check';
const SEL_COMPARE_CONTENT_TEMPLATE = '[data-compare-content-template]';
const SEL_COMPARE_CONTENT = '[data-compare-content]';
const SEL_COMPARE_THUMB_TEMPLATE = '[data-compare-thumb]';
const SEL_COMPARE_THUMB = '[data-compare-thumb]';
const STORAGE_TYPE = 'sessionStorage'; // sessionStorage || localStorage
const STORAGE_KEY_PREFIX_INFO = 'compare-info-html-';
const STORAGE_KEY_PREFIX_THUMB = 'compare-thumb-html-';
const PRODUCTS_LIMIT = 5;
const THUMBS_LIMIT = 9;
const COLUMNS_CSS_PROP = '--products-comparison-popup-columns'

customElements.define('products-comparison', class extends Core {
    propTypes = {
        'checksum': String,
        'products-limit': Boolean,
        'cached': Boolean
    }

    iOSPseudoCounter = 0;
    
    elements = {
        $: [
            'confirm-button', 
            ['cancel'], 
            'button-counter', 
            'thumbs', 
            'table', 
        ],
        'modal': 'modal-container' 
    }

    productsDocs = {};

    render() {
        // this._checkConfiguration();
        this.sub(Events.PRODUCT_COMPARE_CHANGE, this._onChange, {global:  true});
        this.sub(Events.PRODUCT_COMPARE_UPDATE_REQUEST, this._pubState, {global:  true});
        this.$('cancel', { click: this._onCancel });
        this.$('confirm-button', { click: this._onConfirm });
        this._setInitialState();
        this.currentBrowser = getBrowserName();
    }

    // _checkConfiguration() {
    //     const oldChecksum = window[STORAGE_TYPE].getItem(CHECKSUM_STORE_KEY);
    //     Store.get(COMPARING_URLS_STORE_KEY).map(this._removeInfoFromStorage);
    //     if (oldChecksum !== this.prop('checksum')) {
    //         Store.get(COMPARING_URLS_STORE_KEY).map(this._removeInfoFromStorage);
    //         window[STORAGE_TYPE].setItem(CHECKSUM_STORE_KEY, this.prop('checksum'));
    //     }
    // }
    
    // _removeInfoFromStorage(url) {
    //     window[STORAGE_TYPE].removeItem(`${STORAGE_KEY_PREFIX_INFO}${url}`);
    // }
    
    async _setInitialState() {
        await Promise.all(Store.get(COMPARING_URLS_STORE_KEY).map(this._addProduct.bind(this)));
        this._updateState();
    }

    _updateState() {
        if(this.comparingCount === 0) {
            if(this.$('modal')){
              //this.$('modal').close();
            }
        }
        this._setColumnsNumber();
        this._toggleActiveState();
        this._toggleCompareButton();
        this._pubState();
        this._fixIOSCounter();
    }

    _fixIOSCounter() {
        if (this.currentBrowser !== 'Safari') {
            return
        }
        this.iOSPseudoCounter += 1;
        this.style['counter-reset'] = `thumb-count ${this.iOSPseudoCounter}`;
    }

    async _onChange({ url, state, onError, after }) {
        try {
            if(state) {
                this.initialLoading = true;
                await this._addProduct(url);
                Store.add(COMPARING_URLS_STORE_KEY, url);
                this.initialLoading = false;
            } else {
                Store.remove(COMPARING_URLS_STORE_KEY, url);
            }
            this._updateState();
        } catch (error) {
            console.error(error);
            isFunction(onError) && onError();
        } finally {
            isFunction(after) && after();
        }
    }

    set initialLoading(state) {
        if (state && this.comparingCount === 0) {
            $loading(this, state);
            this._initialLoading = true;
        }
        if (!state && this._initialLoading) {
            $loading(this, state);
            this._initialLoading = false;
        }
    }

    async _pubState() {
        await customElements.whenDefined('products-comparison-checkbox');
        this.pub(Events.PRODUCT_COMPARE_UPDATE, {
            comparingProductURLs: Store.get(COMPARING_URLS_STORE_KEY),
            limitReached: this.limitReached
        });
    }
    
    _toggleCompareButton() {
        this._updateCounterValue();
        this.$('confirm-button').toggleAttribute('disabled', this.comparingCount < 2);
    }

    async _addProduct(url) {
        this.loading = true;
        const { $thumb, $infoContent } = await this._getCompareData(url);
        this.$('thumbs').appendChild($clone($thumb));
        this.$('table').appendChild($clone($infoContent));
        this.loading = false;
    }

    async _getCompareData(url) {
        if(this.prop('cached')) {
            if (this.productsDocs[url]) {
                return this.productsDocs[url];
            }
            const info = window[STORAGE_TYPE].getItem(`${STORAGE_KEY_PREFIX_INFO}${url}`);
            const thumb = window[STORAGE_TYPE].getItem(`${STORAGE_KEY_PREFIX_THUMB}${url}`);
            if (info && thumb) {
                const docs = {
                    $infoContent: parseHTML(info).querySelector(SEL_COMPARE_CONTENT),
                    $thumb: parseHTML(thumb).querySelector(SEL_COMPARE_THUMB)
                }
                this.productsDocs[url] = docs;
                return docs;
            }
        }


        const docs = await this._fetchCompareDocs(url);

        if(this.prop('cached')) {
            this.productsDocs[url] = docs;
            this._setToStore(url, docs);
        }

        return docs;
    }
    
    _setToStore(url, data) {
        window[STORAGE_TYPE].setItem(`${STORAGE_KEY_PREFIX_INFO}${url}`, data.$infoContent.outerHTML);
        window[STORAGE_TYPE].setItem(`${STORAGE_KEY_PREFIX_THUMB}${url}`, data.$thumb.outerHTML);
    }
    
    async _fetchCompareDocs(url) {    
        const $doc = await $fetch(`${url}`, { options: {
            sectionId: this.sectionId
        }});
        return {
            $infoContent: $clone($doc.querySelector(SEL_COMPARE_CONTENT_TEMPLATE)).firstElementChild,
            $thumb: $clone($doc.querySelector(SEL_COMPARE_THUMB_TEMPLATE)).firstElementChild,
        }
    }
    
    _onCancel() {
        Store.clear(COMPARING_URLS_STORE_KEY);
        this._updateState();
        // let animation run smoothly
        setTimeout(() => {
            this._clearThumbs();
            this._clearTable();
        }, 300)
    }

    destroy() {
        this._onCancel();
    }

    _clearThumbs() {
        this.$('thumbs').replaceChildren();
    }

    _clearTable() {
        this.querySelectorAll('product-comparison-item').forEach(product => product.remove());
    }

    _onConfirm() {
        this.$('modal').open();
    }

    _toggleActiveState() {
        $active(this, this.comparingCount > 0);
    }

    _setColumnsNumber() {
        this.style.setProperty(COLUMNS_CSS_PROP, this.comparingCount);
    }

    _updateCounterValue() {
        this.$('button-counter').innerText = this.comparingCount;
    }

    get comparingCount() {
        return Store.get(COMPARING_URLS_STORE_KEY).length;
    }

    get limitReached() {
        return this.prop('products-limit') && (PRODUCTS_LIMIT <= this.comparingCount);
    }

    set loading(state) {
        $loading(this.$('confirm-button'), state);
    }
})

customElements.define('product-comparison-item', class extends Core {
    propTypes = {
        'product-url': String
    }

    elements = {
        $: ['remove']
    }
    
    render() {
        this.sub(Events.PRODUCT_COMPARE_CHANGE, this._onChange, {global:  true});
        this.$('remove', { click: this._onRemove });
    }

    _onRemove() {
        this.pub(Events.PRODUCT_COMPARE_CHANGE, {
            url: this.prop('product-url'),
            state: false
        });
        this.remove();
    }

    _onChange({ url, state }) {
        if (!state && url === this.prop('product-url')) {
            this.remove();
        };
    }
})